import * as R from "ramda";
import { createMatchAnyQueryRegex } from "../../common/queryRegex.js";

import { string } from "prop-types";

const propTypes = {
  query: string,
  text: string.isRequired,
};

const HighlightText = (props) => {
  const { query, text } = props;

  if (R.isEmpty(query) || R.isNil(query)) {
    return text;
  }

  // https://stackoverflow.com/questions/469913/regular-expressions-is-there-an-and-operator
  const queryRegex = createMatchAnyQueryRegex(query);

  return R.compose(
    (words) =>
      words.map((word, i) => {
        return queryRegex.test(word) ? (
          <mark key={i} className="highlight-text">
            {word}
          </mark>
        ) : (
          word
        );
      }),
    R.reject(R.isEmpty), // remove empty strings
    R.split("___"),
    R.replace(queryRegex, (match) => `___${match}___`),
  )(text);
};

HighlightText.propTypes = propTypes;
export default HighlightText;
